export const cachedDate = (() => {
  // TODO: add max cache size and move to own file
  const dateCache = new Map<number, Date>();
  let cacheHits = 0;

  return (date: Date | undefined) => {
    if (!date) return undefined;

    const key = date.getTime();
    if (!dateCache.has(key)) {
      dateCache.set(key, date);
    } else {
      cacheHits += 1;
    }

    return dateCache.get(key)!;
  };
})();

export const cachedComplexProps = (() => {
  const propsCache = new Map<string, any>();
  let cacheHits = 0;

  return function cachedProps<TProps>(props: TProps, hashStrategy: (props: TProps) => string) {
    const propsHash = hashStrategy(props);

    let cachedProps: TProps | undefined = propsCache.get(propsHash);

    if (!cachedProps) {
      propsCache.set(propsHash, props);
      cachedProps = props;
    } else {
      cacheHits += 1;
    }

    return cachedProps;
  };
})();

export const simpleCachedComplexPropsHasher = (props: {[key: string]: string | undefined | null}) =>
  Object.keys(props)
    .sort()
    .map((k) => props[k])
    .join(':');
